// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"5d75c9dc443f2bc2b7ca","740":"90fb2a16ace060be6784"}[chunkId] + ".css";
};